export class AuthenticationStages {
    static firstFactor = 'FirstFactor';
    static twoFactor = 'SecondFactor';
    static chooseTwoFactorPreference = 'ChooseTwoFactorPreference';
    static resetPassword = 'ResetPasswrod';
}
